var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1092,
    height: 704,
    viewBox: "0 0 1092 704",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17184_24320)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17184_24320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 32C52 25.3726 57.3726 20 64 20H1028C1034.63 20 1040 25.3726 1040 32V608C1040 614.627 1034.63 620 1028 620H64C57.3726 620 52 614.627 52 608V32Z",
    fill: "#003CE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-128 98L262 490",
    stroke: "#4864F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 490,
    r: 7,
    fill: "#4864F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.888 -124C968.586 -24.3515 947.786 197.956 739 290",
    stroke: "#4864F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 739,
    cy: 290,
    r: 7,
    fill: "#4864F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17184_24320",
    x: 0,
    y: 0,
    width: 1092,
    height: 704,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 12,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_17184_24320"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 32
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0625882 0 0 0 0 0.0926346 0 0 0 0 0.15702 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17184_24320"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17184_24320",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_17184_24320",
    x: 453.5,
    y: 466,
    width: 185,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17184_24320"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17184_24320",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17184_24320"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 32C52 25.3726 57.3726 20 64 20H1028C1034.63 20 1040 25.3726 1040 32V608C1040 614.627 1034.63 620 1028 620H64C57.3726 620 52 614.627 52 608V32Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorBg);
export default __webpack_public_path__ + "static/media/error-bg.476d3d5626bfc5ed9263ca90d2101762.svg";
export { ForwardRef as ReactComponent };